import dashboard from './dashboard'
import general from './general'
import login from './login'
import servicios from './servicios'
import reparaciones from './reparaciones'
import clientes from './clientes'
import filtros from './filtros'
import columnas from './columnas'
import tabs from './tabs'
import adjuntos from './adjuntos'
import equipos from './equipos'
import repuestos from './repuestos'
import compras from './compras'
import remitos from './remitos'
import configuracion from './configuracion'
import habilitaciones from './habilitaciones'
import fallas from './fallas'
import informes from './informes'
import proveedores from './proveedores'
import encuestas from './encuestas'
import sucursales from './sucursales'
import usuarios from './usuarios'
import pagos from './pagos'
import msgError from './msgError'
import mantenimientoVehicular from './mantenimientoVehicular'
import obras from './obras'

export default {
  dashboard,
  general,
  login,
  filtros,
  columnas,
  reparaciones,
  servicios,
  clientes,
  tabs,
  adjuntos,
  equipos,
  repuestos,
  compras,
  remitos,
  configuracion,
  habilitaciones,
  fallas,
  informes,
  proveedores,
  encuestas,
  sucursales,
  usuarios,
  pagos,
  msgError,
  mantenimientoVehicular,
  obras
}